import classNames from 'classnames';
import React, { FC } from 'react';

import { Chips } from '@sbu/components.chips';

import { TagChip, TagChipProps } from './TagChip';
import css from './TagChips.module.scss';

export type TagChipsProps = Omit<TagChipProps, 'tag'> & {
  className?: string;
  tags: string[];
  readOnlyTags?: string[];
};

export const TagChips: FC<React.PropsWithChildren<TagChipsProps>> = ({
  className,
  tags,
  disabled = false,
  readOnlyTags = [],
  editable,
  ...rest
}) => {
  const isTagEditable = (tag: string) =>
    !disabled && !readOnlyTags.includes(tag) && editable;

  return (
    <Chips className={classNames(css.chips, className)}>
      {tags.map((tag: string, index: number) => (
        <TagChip
          data-sumo-test='tag-chip'
          disabled={disabled}
          editable={isTagEditable(tag)}
          key={`tag-chip-${index}`}
          tag={tag}
          {...rest}
        />
      ))}
    </Chips>
  );
};
